<div class="codigo-acesso" role="group" [attr.aria-label]="rotulo">
  <input *ngFor="let indice of indices; trackBy: porIndice"
         #caixa
         class="codigo-acesso__caixa"
         [class.codigo-acesso__caixa--preenchida]="caracteres[indice]"
         [class.codigo-acesso__caixa--invalida]="invalido"
         type="text"
         inputmode="text"
         maxlength="1"
         autocapitalize="characters"
         autocorrect="off"
         spellcheck="false"
         [attr.autocomplete]="indice === 0 ? 'one-time-code' : 'off'"
         [attr.aria-label]="'Caractere ' + (indice + 1) + ' de ' + tamanho"
         [attr.aria-invalid]="invalido"
         [disabled]="disabled"
         (input)="aoDigitar($event, indice)"
         (keydown)="aoTeclar($event, indice)"
         (paste)="aoColar($event, indice)"
         (focus)="aoFocar($event)"
         (blur)="aoSair()" />
</div>
